"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateDocumentPage = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const main_1 = require("../../../../reducers/slices/main");
const document_1 = require("../../../../reducers/slices/document/document");
const create_document_thunk_1 = require("../../../../reducers/slices/document/thunks/create/create_document_thunk");
const console_1 = require("../../../../reducers/slices/console");
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("../../../../constants/routes");
const get_document_thunk_1 = require("../../../../reducers/slices/document/thunks/get/get_document_thunk");
const document_details_1 = require("./components/document_details");
const get_templates_thunk_1 = require("../../../../reducers/slices/document/thunks/get/get_templates_thunk");
const template_preview_card_1 = require("./components/template_preview_card");
const create_document_from_file_thunk_1 = require("../../../../reducers/slices/document/thunks/create/create_document_from_file_thunk");
const create_document_from_template_thunk_1 = require("../../../../reducers/slices/document/thunks/create/create_document_from_template_thunk");
const blank_card_1 = require("./components/blank_card");
const document_upload_card_1 = require("./components/document_upload_card");
const document_overview_thunk_1 = require("../../../../reducers/slices/document/thunks/document_overview_thunk");
const CreateDocumentPage = () => {
    const { document_id } = (0, react_router_dom_1.useParams)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { templates, selectedTemplateID, createFormErrors } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const { token } = (0, react_redux_1.useSelector)((state) => state.userState);
    const [documentInfo, setDocumentInfo] = (0, react_1.useState)({
        name: "",
        only_signer: false,
        signers: [],
    });
    (0, react_1.useEffect)(() => {
        dispatch((0, document_1.setSelectedDocument)(null));
        dispatch((0, document_1.setSelectedDocumentElements)([]));
        dispatch((0, document_1.setSelectedTemplateID)("blank"));
        dispatch((0, document_1.setSelectedElementID)(""));
        dispatch((0, console_1.setPageTitle)("Create Document"));
        dispatch((0, console_1.setShowMenu)(true));
    }, []);
    (0, react_1.useEffect)(() => {
        dispatch((0, console_1.setShowMenu)(true));
        if (token) {
            dispatch((0, get_templates_thunk_1.get_templates_thunk)({
                data: {
                    page: 1,
                    size: 10,
                },
            }));
            if (document_id) {
                dispatch((0, get_document_thunk_1.get_document_thunk)({
                    data: {
                        _id: document_id,
                    },
                }));
            }
            else {
                dispatch((0, document_1.setSelectedDocument)(null));
                dispatch((0, document_1.setSelectedDocumentElements)([]));
            }
        }
    }, [token]);
    // Enhanced email validation using browser's native validator
    const validateEmail = (email) => {
        // Basic format check first
        const basicEmailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        if (!basicEmailRegex.test(email)) {
            return false;
        }
        // Use browser's native email validation for comprehensive check
        // This catches issues like invalid TLDs (.glabal instead of .global)
        const input = window.document.createElement("input");
        input.type = "email";
        input.value = email;
        return input.checkValidity();
    };
    const validate = () => {
        let messages = createFormErrors.filter((x) => x != "");
        if (!documentInfo.name)
            messages.unshift("Document name is required");
        // Validate emails if not "only signer"
        if (!documentInfo.only_signer && documentInfo.signers.length > 0) {
            documentInfo.signers.forEach((signer, index) => {
                if (!signer.email) {
                    messages.push(`Email (${index + 1}) is required`);
                }
                else if (!validateEmail(signer.email)) {
                    messages.push(`Invalid email (${index + 1}) format. Please check for typos (e.g., .glabal should be .global)`);
                }
            });
        }
        if (messages.length > 0) {
            dispatch((0, main_1.setMessageModal)({
                title: "Validation Error",
                messages: messages,
            }));
            return false;
        }
        return true;
    };
    const saveDocumentFromFile = (file) => __awaiter(void 0, void 0, void 0, function* () {
        if (!validate())
            return;
        const _signers = JSON.stringify(documentInfo.signers);
        dispatch((0, create_document_from_file_thunk_1.create_document_from_file_thunk)({
            data: Object.assign(Object.assign({ file: file, pages: 1, status: "DRAFT", type: "DOCUMENT" }, documentInfo), { signers: _signers }),
            callback: (data) => {
                navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENT_ROUTE}/${data === null || data === void 0 ? void 0 : data._id}`);
            },
        }));
    });
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4 px-2 sm:px-0" },
        react_1.default.createElement("div", { className: "rounded-md overflow-hidden" },
            react_1.default.createElement(document_details_1.DocumentDetails, Object.assign({}, { documentInfo, setDocumentInfo }))),
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Select the Template" })),
        react_1.default.createElement("div", { className: "grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-2 sm:gap-3" },
            react_1.default.createElement(document_upload_card_1.DocumentUploadCard, { onUpload: (file) => {
                    if (!validate())
                        return;
                    saveDocumentFromFile(file);
                }, disabled: !documentInfo.name || (!documentInfo.only_signer && (documentInfo.signers.length === 0 || documentInfo.signers.some((s) => !s.email))) }),
            react_1.default.createElement(blank_card_1.BlankCard, null),
            templates.map((template) => (react_1.default.createElement(template_preview_card_1.TemplatePreviewCard, { key: template._id, template: template, onClick: () => {
                    dispatch((0, document_1.setSelectedTemplateID)(template._id));
                } })))),
        react_1.default.createElement("div", { className: "flex justify-center mb-4" },
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Save Document", size: "small", backgroundColor: "bg-secondary", textColor: "text-white", enabled: !!documentInfo.name && (documentInfo.only_signer || (documentInfo.signers.length > 0 && !documentInfo.signers.some((s) => !s.email))), onClick: () => {
                    if (!validate())
                        return;
                    const callback = (data) => {
                        dispatch((0, document_overview_thunk_1.document_overview_thunk)());
                        navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENT_ROUTE}/${data === null || data === void 0 ? void 0 : data._id}`);
                    };
                    if (selectedTemplateID === "blank") {
                        dispatch((0, create_document_thunk_1.create_document_thunk)({
                            data: Object.assign(Object.assign({}, documentInfo), { pages: 1 }),
                            callback,
                        }));
                    }
                    else {
                        dispatch((0, create_document_from_template_thunk_1.create_document_from_template_thunk)({
                            data: Object.assign({ template_id: selectedTemplateID }, documentInfo),
                            callback,
                        }));
                    }
                } }))));
};
exports.CreateDocumentPage = CreateDocumentPage;
